import styled from "styled-components";

const IndividualContainer = styled.div`
  padding: 10px 20px;
`;

export default IndividualContainer;
